import React, { useState } from 'react';
import "../../Styles/HostelAllotment.css";

function HostelAllotment() {
  // State for active tab
  const [activeTab, setActiveTab] = useState('all');
  // State for search query
  const [searchQuery, setSearchQuery] = useState('');
  // State for selected students
  const [selectedStudents, setSelectedStudents] = useState([]);
  // State for select all checkbox
  const [selectAll, setSelectAll] = useState(false);

  // Sample student data
  const students = [
    { id: 1, name: 'John Doe', gender: 'male', department: 'Computer Science', year: '3rd' },
    { id: 2, name: 'Jane Smith', gender: 'female', department: 'Physics', year: '2nd' },
    { id: 3, name: 'Mike Johnson', gender: 'male', department: 'Mechanical', year: '1st' },
    { id: 4, name: 'Sarah Williams', gender: 'female', department: 'Electrical', year: '4th' },
    { id: 5, name: 'David Brown', gender: 'male', department: 'Civil', year: '2nd' },
    { id: 6, name: 'Emily Davis', gender: 'female', department: 'Chemical', year: '3rd' },
  ];

  // Filter students based on active tab and search query
  const filteredStudents = students.filter(student => {
    const matchesTab = activeTab === 'all' || 
                      (activeTab === 'boys' && student.gender === 'male') || 
                      (activeTab === 'girls' && student.gender === 'female');
    
    const matchesSearch = student.name.toLowerCase().includes(searchQuery.toLowerCase()) || 
                          student.department.toLowerCase().includes(searchQuery.toLowerCase());
    
    return matchesTab && matchesSearch;
  });

  // Handle tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSelectAll(false);
    setSelectedStudents([]);
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Handle individual checkbox change
  const handleCheckboxChange = (studentId) => {
    if (selectedStudents.includes(studentId)) {
      setSelectedStudents(selectedStudents.filter(id => id !== studentId));
    } else {
      setSelectedStudents([...selectedStudents, studentId]);
    }
  };

  // Handle select all checkbox change
  const handleSelectAllChange = () => {
    if (!selectAll) {
      setSelectedStudents(filteredStudents.map(student => student.id));
    } else {
      setSelectedStudents([]);
    }
    setSelectAll(!selectAll);
  };

  // Handle submit button click
  const handleSubmit = () => {
    console.log('Selected Students:', selectedStudents);
    alert(`Selected ${selectedStudents.length} students for hostel allotment.`);
  };

  return (
    <div className="hostel-allotment-container">
      <h1 className="hostel-title">Hostel Allotment System</h1>
      
      {/* Tabs Navigation */}
      <div className="tabs-container">
        <div 
          className={`tab ${activeTab === 'all' ? 'active' : ''}`} 
          onClick={() => handleTabChange('all')}
        >
          All
        </div>
        <div 
          className={`tab ${activeTab === 'boys' ? 'active' : ''}`} 
          onClick={() => handleTabChange('boys')}
        >
          Boys
        </div>
        <div 
          className={`tab ${activeTab === 'girls' ? 'active' : ''}`} 
          onClick={() => handleTabChange('girls')}
        >
          Girls
        </div>
      </div>

      {/* Search and Action Area */}
      <div className="search-container">
        <input
          type="text"
          placeholder="Search by name or department..."
          value={searchQuery}
          onChange={handleSearchChange}
          className="search-input"
        />
      </div>

      {/* Students Table */}
      <div className="table-container">
        <table className="students-table">
          <thead>
            <tr>
              <th className="checkbox-column">
                <input 
                  type="checkbox" 
                  checked={selectAll} 
                  onChange={handleSelectAllChange}
                />
              </th>
              <th>ID</th>
              <th>Name</th>
              <th>Gender</th>
              <th>Department</th>
              <th>Year</th>
            </tr>
          </thead>
          <tbody>
            {filteredStudents.length > 0 ? (
              filteredStudents.map(student => (
                <tr key={student.id}>
                  <td className="checkbox-column">
                    <input 
                      type="checkbox" 
                      checked={selectedStudents.includes(student.id)} 
                      onChange={() => handleCheckboxChange(student.id)}
                    />
                  </td>
                  <td>{student.id}</td>
                  <td>{student.name}</td>
                  <td>{student.gender === 'male' ? 'Male' : 'Female'}</td>
                  <td>{student.department}</td>
                  <td>{student.year}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="no-results">No students found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Action Buttons */}
      <div className="action-buttons">
        <div className="selected-info">
          {selectedStudents.length} student(s) selected
        </div>
        <button 
          className="submit-button" 
          onClick={handleSubmit}
          disabled={selectedStudents.length === 0}
        >
          Submit Allotment
        </button>
      </div>
    </div>
  );
}

export default HostelAllotment;